import $apiJSON from 'http/apiJSON'

const BASE = '/admin-panel'

export const get2FAStatus = () => $apiJSON.get(`${BASE}/2fa/status/`)
export const setup2FA = () => $apiJSON.get(`${BASE}/2fa/setup/`)
export const verify2FA = (code) => $apiJSON.post(`${BASE}/2fa/verify/`, { code })
export const disable2FA = (password) => $apiJSON.post(`${BASE}/2fa/disable/`, { password })
export const requestUnlock = (email) => $apiJSON.post(`${BASE}/unlock-request/`, email ? { email } : {})
export const postLogin = () => $apiJSON.get(`${BASE}/post-login/`)

export default {
  get2FAStatus,
  setup2FA,
  verify2FA,
  disable2FA,
  requestUnlock,
  postLogin,
}
